import { User } from "oidc-client-ts";
import { getOidcKey } from "../config/auth0";
import { get, post } from "../utils/fetch";
import { Store } from "../config/store";
import { BatchEntry } from "../types/app.interfaces";
import {
  _batchInv,
  _isInvestBatchedRequestScheduled,
  _makeRemoteRequest,
  setIsInvestBatchedRequestScheduled,
} from "../utils/batching";
import { getStringFromStorage } from "../utils/storagehelper";
import { ProfileSettings } from "../types/app.storage.enums";
import { getApiConfig } from "../config/apiconfig";

export class BaseService {
  OidcKey: string;
  APICONFIG: any = {};

  constructor() {
    this.OidcKey = getOidcKey();
    this.APICONFIG = getApiConfig();
  }

  getToken(): string {
    const oidcuser = Store.getItem(this.OidcKey);
    const user = User.fromStorageString(oidcuser);
    return user.access_token;
  }

  getProfileId(): string {
    return Store.getItem(ProfileSettings.ProfileId);
  }

  getUser(): User {
    const oidcuser = Store.getItem(this.OidcKey);
    const user = User.fromStorageString(oidcuser);
    return user;
  }

  invokeGet(url): any {
    return get(this.getToken(), url);
  }

  invokePost(url, payload) {
    return post(this.getToken(), url, payload);
  }

  _pushOperation(op: string, args: any, apiUrl: any, functionGroup: any) {
    // Create an entry for your custom function.
    const invocationEntry: BatchEntry = {
      operation: op, // e.g. sum
      args: args,
      resolve: undefined,
      reject: undefined,
      apiUrl: apiUrl,
      functionGroup: functionGroup,
    };

    // Create a unique promise for this invocation,
    // and save its resolve and reject functions into the invocation entry.
    const promise = new Promise((resolve, reject) => {
      invocationEntry.resolve = resolve;
      invocationEntry.reject = reject;
    });

    // Push the invocation entry into the next batch.
    _batchInv.push(invocationEntry);

    // If a remote request hasn't been scheduled yet,
    // schedule it after a certain timeout, e.g. 100 ms.

    if (!_isInvestBatchedRequestScheduled) {
      setIsInvestBatchedRequestScheduled(true);
      window.setTimeout(() => {
        const profileid = getStringFromStorage(ProfileSettings.ProfileId);
        const accesstoken = this.getToken();
        _makeRemoteRequest(accesstoken, profileid);
      }, 1000);
    }

    // Return the promise for this invocation.
    return promise;
  }
}
